import { Component } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'topo-app-disclaimer',
  imports: [TranslatePipe],
  templateUrl: './app-disclaimer.component.html'
})
export class AppDisclaimerComponent {}
